import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export const Page: FC<{ children: ReactNode }> = ({ children }) => {
  return <PageComponent className="flex-1 page main-page w-full">{children}</PageComponent>;
};

const PageComponent = styled.div`
  max-width: var(--page-width);
  margin: 0 auto 3rem auto;
`;
